import {
    BusinessDashboardResponse,
    InternalDashboardResponse,
} from '@barboxx/types';

import { api } from '../api';

const rootPath = 'admin/dashboard';

export function getInternalDashboardSummary() {
    return api.get<InternalDashboardResponse>(rootPath);
}

export function getBusinessDashboardSummary() {
    return api.get<BusinessDashboardResponse>(`${rootPath}/business`);
}
